import clsx from 'clsx';
import React, { type PropsWithChildren } from 'react';

import { Tooltip } from '../../Tooltip/Tooltip';

type SecondaryButtonV3Props = {
  onClick: VoidFunction;
  className?: string;
  disabled?: boolean;
  disabledTooltipText?: string;
  'data-testid'?: string;
};
export const SecondaryButtonV3 = ({
  children,
  onClick,
  className,
  disabled = false,
  disabledTooltipText,
  'data-testid': testId,
}: PropsWithChildren<SecondaryButtonV3Props>) => (
  <Tooltip
    tooltipComponent={<span className="text-main">{disabledTooltipText}</span>}
    tooltipDisabled={!disabled || !disabledTooltipText}
    placement="top-start"
    delayShow={500}
    delayHide={500}
    baseComponent={
      <button
        type="button"
        disabled={disabled}
        onClick={onClick}
        data-testid={testId}
        className={clsx(
          'flex items-center justify-center',
          'p-[4px] px-[9px]',
          'font-helvetica text-md rounded-[2px]',
          disabled
            ? 'bg-main-200 text-main-500 hover:cursor-not-allowed'
            : 'bg-main-200 text-main hover:bg-negative hover:text-main hover:cursor-pointer',
          'transition-colors',
          className
        )}
      >
        {children}
      </button>
    }
  />
);
